import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, IBorderRefusal } from '../../../../../types';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

function VisaPrepAdditionalHistoryStep6Info(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  const renderBorderRefusals = () => {
    const allBorderRefusals: React.ReactNode[] = [];
    if (props.borderRefusals && props.borderRefusals.length) {
      props.borderRefusals.forEach((borderRefusal: IBorderRefusal, i: number) => {
        allBorderRefusals.push(
          <SummaryGroup title={t('forms.visa:borderRefusal', { i: i + 1 })} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.BORDER_REFUSAL_DATE}-${i}`}
              label={t('forms.visa:dateOfRefusal')}
              value={borderRefusal.refusalDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.BORDER_REFUSAL_AIRPORT}-${i}`}
              value={borderRefusal.airport}
              label={t('forms.visa:portOrAirport')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.BORDER_REFUSAL_REASON}-${i}`}
              value={borderRefusal.reason}
              label={t('forms.visa:reason')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.BORDER_REFUSAL_REFERENCE}-${i}`}
              value={borderRefusal.reference}
              label={t('forms.visa:referenceNumber')}
            />
          </SummaryGroup>,
        );
      });
    }
    return allBorderRefusals;
  };
  return (
    <>
      <SummaryRow className={'visa-summary'} label={t('forms.visa:numberOfBorderRefusals')} value={props.borderRefusals?.length} />

      <Box as="ol" pl={8} key={'border-refusals'}>
        {renderBorderRefusals()}
      </Box>
    </>
  );
}

export default VisaPrepAdditionalHistoryStep6Info;
